import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ImageCompare from "image-compare-viewer";

const [w,d,mq] = [window,document,window.matchMedia('(max-width: 901px)')];

class compair {
  constructor(viewers = [], opt = { addCircle: true }) {
    if(viewers.length > 0) viewers.forEach( elem => new ImageCompare(elem,opt).mount());
  }
}

class scrollevent {
  constructor(){
    gsap.registerPlugin( ScrollTrigger );
    this.init();
  }

  init() {
    this.mainvisual();
    this.intro();
    w.addEventListener('load', () => this.feature());
  }

  mainvisual () {
    let container = d.querySelector('.uav-mainvisual');
    let imgs = d.querySelectorAll('.uav-mainvisual img');
    let imgLoad = [];
    imgs.forEach( img => {
      imgLoad.push(new Promise( resolve => img.addEventListener('load', () => resolve() ) ));
    });
    Promise.all([imgLoad]).then( () => container.classList.add('is-ready'));

    ScrollTrigger.create({
      trigger: '.uav-mainvisual', //アニメーションが始まるトリガーとなる要素
      start: 'top -25%',
      toggleClass: {targets: ".uav-mainvisual", className: "is-disp-desc"},
      // markers: true,
    });
  }

  intro (){

    ScrollTrigger.create({
      trigger: '.uav-intro-figure', //アニメーションが始まるトリガーとなる要素
      start: 'top top',
      toggleClass: {targets: ".uav-intro-figure__speclist", className: "is-active"},
      // markers: true,
      // once: true,
    });

    ScrollTrigger.create({
      trigger: '.uav-intro__movie-wrap', //アニメーションが始まるトリガーとなる要素
      start: 'top bottom',
      end: 'bottom top',
      toggleClass: {targets: ".uav-intro__movie", className: "is-fixed"},
      // markers: true,
      // once: true,
    });
  }

  feature() {
    gsap.fromTo('.is-feature01 .uav-feature__img', {
      y: (mq.matches)? -50 : -150
    },{ //アニメーションしたい要素を指定
      y: (mq.matches)? 20: 50,
      scrollTrigger: {
        trigger: '.uav-feature.is-feature01',//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置を指定
        end: 'bottom top',
        scrub: true,
        // markers: true,
      }
    });

  }
}

export default function UAV3D () {
  d.addEventListener('DOMContentLoaded', () => {
    const compair_imgs = d.querySelectorAll('[data-plugin="compair-img"]');
    if( compair_imgs.length ) new compair(compair_imgs);

    new scrollevent;
  });

}